<template>
  <div>
    <PersonContentLoader v-if="loading" />

    <div v-if="!loading" :style="disabled ? 'opacity: 40%' : ''"
         :class="$store.getters.user.role !== 'p' && $store.getters.user.role !== 'o' ? 'patient-card d-flex flex-wrap pa-2': ''">
      <div style="height: 100%; width: 35%" class="">
        <div v-if="patient && !person.isArchived">
          <p>
            <span class="pink--text">{{ $t("general.patient.crib") }}</span>
            {{ person.crib }}
          </p>
        </div>
        <auto-rotate>
          <img
            @click="!disabled ? $emit('select-person') : null"
            v-if="(!person.profilePicture && person.role !== 'n' && person.role !== 'a') || ((person.role === 'n' || person.role === 'a') && !person.upload)"
            src="@/assets/images/nophoto.png"
            :class="{ 'no-click': disabled }"
            :alt="`Profile picture of ${person.firstName}`"
          />
          <img
            @click="!disabled ? $emit('select-person') : null"
            v-else
            :class="{ 'no-click': disabled }"
            :src="person.profilePicture ? person.profilePicture.blobUri : person.upload.blobUri"
            :alt="`Profile picture of ${person.firstName}`"
          />
        </auto-rotate>

        <div class="information" v-if="patient">
      <span class="person-name">
        <a @click="$emit('select-person')">{{ person.firstName }}</a>
        <Button
          v-if="!noLink"
          class="edit-person-button"
          color="#00A9B3"
          bgcolor="transparent"
          width="30px"
          padding="0"
          icon="pen-pink"
          @click.native="$emit('edit-person')"
        ></Button>
      </span>

          <div v-if="!person.isArchived && !person.isDeceased" class="patient-information">
            <a @click.prevent="selectPatientForVisit(person)">
          <span class="pink--text visit-label"
          >{{ $t("app.evolution.title") }} ></span
          >
            </a>
            <br>
            <span v-if="person.visits">{{$t("app.visit.nextVisit") }}: <br>{{ person.visits[0].dateTime | moment("D MMMM YYYY - HH:mm") }}</span>
          </div>
          <div v-if="person.isDeceased" class="patient-information">{{ $t("app.patient.isDeceased") }}</div>
        </div>

        <div class="information" v-else>
          <p class="person-name">
            <template v-if="!noLink">
              <a @click="$emit('select-person')" v-if="person.nickName && person.nickName.length > 0">{{ person.nickName }}</a>
              <a @click="$emit('select-person')" v-else>{{ person.firstName }} {{ person.lastName }}</a>
            </template>
            <template v-else>
              <p v-if="person.nickName && person.nickName.length > 0">{{ person.nickName }}</p>
              <p v-else>{{ person.firstName }} {{ person.lastName }}</p>
            </template>
            <Button
              v-if="!noLink"
              class="edit-person-button"
              color="#00A9B3"
              bgcolor="transparent"
              width="30px"
              padding="0"
              icon="pen-pink"
              @click.native="$emit('edit-person')"
            ></Button>
          </p>
        </div>
      </div>

      <v-divider class="pa-3" vertical></v-divider>
      <div v-if="patient === true" style="height: 100%; width: 45%; display: flex !important" class="flex flex-column pa-3 flex-wrap">
        <p>{{ $t("app.patient.lastActiveHospital") }}: {{ person.lastActivityHospital }}</p>
        <v-divider class="pa-2"></v-divider>
        <p v-for="parent in parents" :key="parent.id">
          <template v-if="parent.active">
            {{ $t("app.patient.activeParent") }}: <br> {{parent.firstName}} {{parent.lastName}} ({{ others.filter(x => x.invitedBy === parent.id).length }})
          </template>
          <template v-else>
            {{ $t("app.patient.passiveParent") }}: <br> {{parent.firstName}} {{parent.lastName}} ({{ others.filter(x => x.invitedBy === parent.id).length }})
          </template>
          <template v-if="parent.lastActivity">- {{parent.lastActivity}}</template>
        </p>
        <p v-if="!parents.length">{{ $t("app.patient.noActivatedParents") }}</p>
      </div>

      <div v-if="patient !== true && $store.getters.user.role !== 'p' && $store.getters.user.role !== 'o'" style="height: 100%; width: 45%; display: flex !important" class="flex flex-column pa-3 flex-wrap">
        <template v-if="!person.isArchived">
          <p v-if="(!$store.getters.user.hospital || !$store.getters.user.hospital.epdSettings || !$store.getters.user.hospital.epdSettings.epdEnabled) && person.invitedAt">{{ $t("dash.nurse.invitedOn") }}: {{ person.invitedAt | moment("L") }}</p>
          <p>{{ $t("dash.nurse.activeSince") }}: {{ person.createdAt | moment("L") }}</p>
        </template>
        <template v-else>
          <p>{{ $t("dash.nurse.activatedOn") }}: {{ person.createdAt | moment("L") }}</p>
          <p>{{ $t("dash.nurse.archivedSince") }}: {{ person.updatedAt | moment("L") }}</p>
        </template>
      </div>

    </div>
  </div>
</template>

<script>
import {curaeConsent, neoparentPatients, neoparentUsers} from "@/api";

export default {
  name: "Person",
  props: {
    person: { required: true },
    patient: Boolean,
    noLink: Boolean,
    disabled: Boolean
  },
  data() {
    return {
      loading: true,
      parents: [],
      others: []
    };
  },
  async mounted() {
    await this.getPersonData()
  },
  methods: {
    selectPatientForVisit(patient) {
      neoparentUsers.selectPatient(patient.id)
        .then(() => {
          location.href = "/profile/evolution"
        })
    },
    async getPersonData() {
      if (!this.patient) {
        this.loading = false
      } else {
        await this.getParents()
        await this.getOthers()
        await this.getLatestActivityForHospital()
        this.loading = false
      }
    },
    async getParents() {
      const res = await neoparentPatients.getPatientParents(this.person.id)
      if (res.data && res.data.parents.length) {
        this.parents = res.data.parents

        for (let ndx in this.parents) {
          //Get latest user activity for patient
          this.parents[ndx].lastActivity = await this.getLatestActivityDateTimeForUserAndPatient(this.parents[ndx].id, this.person.id);

          if (this.$store.getters.user.hospital.useCuraeConsent) {
            //Check user consent
            this.parents[ndx].active = await this.isUserConsentGiven(this.parents[ndx].id)
          } else {
            this.parents[ndx].active = true
          }
        }
      }
    },
    async getOthers() {
      const res = await neoparentPatients.getPatientOthers(this.person.id)
      if (res.data && res.data.others.length) {
        this.others = res.data.others
      }
    },
    async isUserConsentGiven(userId) {
      const res = await curaeConsent.getUserConsent(userId)
      return res.data.consentGiven
    },
    async getLatestActivityDateTimeForUserAndPatient(userId, patientId) {
      const res = await neoparentUsers.getLatestActivityForPatientAndUser(patientId, "USER", userId)

      if (res.data && res.data.dateTime && res.data.dateTime.length) {
        return this.$moment(res.data.dateTime).format('L')
      }

      return null
    },
    async getLatestActivityForHospital() {
      const res = await neoparentUsers.getLatestActivityForPatientAndHospital(this.person.id, "HOSPITAL")

      if (res.data && res.data.dateTime && res.data.dateTime.length) {
        this.person.lastActivityHospital = this.$moment(res.data.dateTime).format('L')
      }

      return null
    }
  },
};
</script>

<style scoped>
img {
  margin: auto;
  border-radius: 50%;
  height: 100px;
  width: 100px;
  cursor: pointer;
  object-fit: cover;
}

.patient-information p {
  margin: 0;
}

.person-name a {
  cursor: pointer;
}

.visit-label {
  text-decoration: underline;
  cursor: pointer;
}

.patient-card {
  border: black solid 1px;
  border-color: #e57378;
  margin: auto;
  width: auto;
}

.no-click {
  cursor: default;
}

</style>
